export default {
  SCHOOL: 1,
  SCHOOL_MUNICIPALITY: 2,
  MUNICIPALITY_HOME: 3,
  FREE_SELECTION: 4,
};
